export const sectionStyles = {
  py: '60px',
}
